import { CpUserInfoChecker, provideCpUserInfoChecker } from '@v2/logic/services/cp-user-info-checker';
import { initializeThirdPartyShared } from '@v2/third-party/shared/third-party';
import { Environment, registerEnvironment } from '../environment';
import { registerEnvironmentCp } from '../environment-cp';
import { environmentShared } from '../shared/environmentShared';
import { projectShared } from '../shared/projectShared';
import { registerOptimove } from '../tokens/optimove-token';
import { registerProject } from '../tokens/project-token';
import { getEnvironmentCp } from '../utilities/env-checker';
import { environment as environmentCpDev } from './cp/environment.dev';
import { environment as environmentCpProd } from './cp/environment.prod';

export function initEnvironment(): void {
  const environment: Environment = {
    brandName: 'energycasino',
    device: 'web',
    ...environmentShared
  };
  registerEnvironment(environment);
  registerEnvironmentCp(getEnvironmentCp(environmentCpDev, environmentCpProd));

  const cpUserInfoChecker: CpUserInfoChecker = provideCpUserInfoChecker();
  cpUserInfoChecker.init();

  registerOptimove({
    tenantId: '311',
    tenantToken: '4fbe60777c9d4dbbb7d5377b23df2cd7'
  });
  registerProject(projectShared);

  initializeThirdPartyShared(environment);
}
